
import React from 'react'
import { useEffect } from 'react';
import { Check } from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext';

import "./customicons.css"

const CopyWithTimeout = () => {

  const {
    isTextCopied,
    setIsTextCopied, 
} = React.useContext(StatusContext);

  useEffect(() => {

    // Set a timer to hide the icon after 0.5 seconds
    const timer = setTimeout(() => {
      let a = {
        id: -1,
        status : false
      }

      setIsTextCopied(a);
    }, 500);

    // Cleanup the timer when the component unmounts or if it changes
    return () => clearTimeout(timer);
  }, [setIsTextCopied]); // Empty dependency array means this effect runs once on mount

  return (
    <div>
      {isTextCopied && <Check className="promptCopyIcon"/>} {/* Display the icon if visible */}
    </div>
  );
};

export default CopyWithTimeout;

  




